/**
 * @param {import("../../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels/documentations/categories",
    },
    (router) => {
      router.push({
        id: "@api/hotel.documentation.category@search",
        path: "",
      });

      router.group(
        {
          path: "/:hotelDocumentationCategoryId",
        },
        (router) => {
          router.push({
            id: "@api/hotel.documentation.category@show",
            path: "",
          });
        },
      );
    },
  );
}
